import uiRouter from 'angular-ui-router';
import indexComponent from './index.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

import devChangeEmployee from './devChangeEmployee/devChangeEmployee';

let indexModule = angular.module('components.index', [
  uiRouter, devChangeEmployee
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.INDEX, {
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.INDEX,
        component: 'index',
        data: {
          requiresAuth: true
        }
      });
  })

  .component('index', indexComponent)

  .name;

export default indexModule;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/index.js